// MainLayout.jsx
import { Box, Toolbar, useMediaQuery, useTheme } from "@mui/material";
import Sidebar from "../components/Sidebar/Sidebar";
import Navbar from "./Navbar";
import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { ROUTES } from "../constants/routes";

// const drawerWidth = 240;

export default function MainLayout({ children }) {
      const location = useLocation();
    const theme = useTheme();
   const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const hideSidebarRoutes = [
    ROUTES.ADMINFORGOTPASSWORD,
    ROUTES.ADMINSIGNIN,
    ROUTES.PRIVACYPOLICY,
    ROUTES.TERMS,
  ];

   const hideLayout = hideSidebarRoutes.includes(location.pathname);
    useEffect(() => {
    if (!isMobile) {
      setSidebarOpen(true);
    } else {
      setSidebarOpen(false);
    }
  }, [isMobile]);

  const toggleSidebar = () => setSidebarOpen((prev) => !prev);

  const handleOutsideClick = () => {
    if (isMobile && sidebarOpen) setSidebarOpen(false);
  };
    return (
        <Box sx={{ display: "flex" }} className="app-layout">
          {hideLayout ? 
        <>
            <Box
                component="main"
                // sx={{ flexGrow: 1, ml: `${drawerWidth}px`, minHeight: '100vh' }}
                sx={{ flexGrow: 1, minHeight: 'calc(100vh - 64px)',width:'100%',overflow:'auto', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            >
                {/* <Toolbar /> */}
                  <Outlet />
                {children}
            </Box>
        </> : 
        <>
            <Sidebar open={sidebarOpen} toggleSidebar={() => setSidebarOpen(!sidebarOpen)}/>
            <Box
                component="main"
                // sx={{ flexGrow: 1, ml: `${drawerWidth}px`, minHeight: '100vh' }}
                sx={{ flexGrow: 1, minHeight: 'calc(100vh - 64px)',mt:'64px',p:'16px',width:'100%',overflow:'auto' }}
            >
                <Navbar open={sidebarOpen} toggleSidebar={() => setSidebarOpen(!sidebarOpen)}/>
                {/* <Toolbar /> */}
                <Outlet />
                {children}
            </Box>
        </>
        }
           
        </Box>
    );
}
